import styled, {css} from 'styled-components'

export default {
	Wrapper: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 56px 28px;
		gap: 40px;
	`,

	TitleDiv: styled.div`
		display: flex;
		justify-content: space-between;
		align-items: center;

		& > h2 {
			${({theme}) => theme.font['xlarge-semibold']};
		}
	`,

	TitleRight: styled.div`
		display: flex;
		align-items: center;
		justify-content: end;
		gap: 12px;
		width: 50%;

		& > button.filter-btn {
			display: flex;
			align-items: center;
			gap: 4px;

			& > p {
				${({theme}) => theme.font['xsmall-regular']};
			}

			& > img {
				height: 10px;
			}
		}
	`,

	InfoBtn: styled.button`
		display: flex;
		align-items: center;
		gap: 4px;
		padding: 6px 10px;
		border: 1px solid ${({theme}) => theme.color['grey2']};
		border-radius: 4px;
		background-color: ${({theme}) => theme.color['white']};

		& > p {
			${({theme}) => theme.font['xsmall-medium']};
			color: ${({theme}) => theme.color['black']};
		}

		& > img {
			width: 14px;
			height: 14px;
		}
	`,

	MyInfoDiv: styled.div`
		height: 72px;
		display: flex;
		align-items: center;
		padding: 8px 0;
		background-color: ${({theme}) => theme.color['black']};
		border-radius: 8px;
	`,
	MyInfoElement: styled.div`
		flex-grow: 1;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: 4px;

		& > h1 {
			${({theme}) => theme.font['medium-bold']};
			color: ${({theme}) => theme.color['white']};
		}

		& > h2 {
			${({theme}) => theme.font['xsmall-regular']};
			color: ${({theme}) => theme.color['white']};
		}

		& > p {
			${({theme}) => theme.font['small-semibold']};
			color: ${({theme}) => theme.color['white']};
			height: 20px;
			display: flex;
			align-items: center;
		}

		${({$border}) =>
			$border &&
			css`
				border-right: 1px solid ${({theme}) => theme.color['white']};
			`}
	`,
	TierWrapper: styled.div`
		display: flex;
		align-items: flex-end;
		gap: 4px;
		justify-content: start;
	`,
	MyTier: styled.h3`
		${({theme}) => theme.font['xsmall-medium']};
		height: 20px;
		line-height: 20px;
		display: flex;
		vertical-align: bottom;

		color: ${({theme, $tier}) => {
			if ($tier === 'CHALLENGER') return theme.color['challenger']
			else if ($tier === 'DIAMOND') return theme.color['diamond']
			else if ($tier === 'PLATINUM') return theme.color['platinum']
			else if ($tier === 'GOLD') return theme.color['gold']
			else if ($tier === 'SILVER') return theme.color['silver']
			else if ($tier === 'BRONZE') return theme.color['bronze']
			else return theme.color['white']
		}};
	`,

	RankingList: styled.table`
		width: 100%;
		margin-top: 16px;
		border-collapse: collapse;
	`,
	RankingElement: styled.tr`
		border-bottom: 1px solid ${({theme}) => theme.color['grey1']};
	`,
	Rank: styled.td`
		${({$upper, theme}) =>
			$upper ? theme.font['medium-bold'] : theme.font['medium-medium']};
		padding: 12px 0;
	`,
	Name: styled.td`
		${({$upper, theme}) =>
			$upper ? theme.font['medium-bold'] : theme.font['medium-medium']};
		text-align: start;
		max-width: 120px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	`,
	Tier: styled.td`
		& p {
			display: flex;
			align-items: center;
			padding: 4px 12px;
			${({theme}) => theme.font['xsmall-regular']};
			background-color: red;
			border-radius: 9999px;
			color: ${({theme}) => theme.color['white']};

			background-color: ${({theme, $tier}) => {
				if ($tier === 'CHALLENGER') return theme.color['challenger']
				else if ($tier === 'DIAMOND') return theme.color['diamond']
				else if ($tier === 'PLATINUM') return theme.color['platinum']
				else if ($tier === 'GOLD') return theme.color['gold']
				else if ($tier === 'SILVER') return theme.color['silver']
				else if ($tier === 'BRONZE') return theme.color['bronze']
			}};
		}
	`,
	Info: styled.td`
		${({$upper, theme}) =>
			$upper ? theme.font['medium-bold'] : theme.font['medium-medium']};
		text-align: end;
	`,

	Option: styled.p`
		${({theme}) => theme.font['xsmall-medium']};
	`,
	Caution: styled.p`
		width: 100%;
		text-align: center;
		${({theme}) => theme.font['large-medium']};
		color: ${({theme}) => theme.color['white']};
	`,
}
